module.exports = __webpack_public_path__ + "static/img/question.22eeedd4.png";